export const topicChartColors = ['#a01743', '#008f72', '#36b7f1', '#ff1f89', '#00d9be', '#ffb232', '#004aa1', '#95ca15', '#677b0e', '#ffa8ec'];